import _Array$isArray from "core-js/library/fn/array/is-array.js";
function _arrayWithHoles(r) {
  if (_Array$isArray(r)) return r;
}
export { _arrayWithHoles as default };